import React from 'react';

import styled, { css, useTheme } from 'styled-components';
import Icon, { type IconType } from '~/components/atom/Icon';
import JustificationContainer from '~/components/atom/JustificationContainer';
import useHover from '~/components/bad/util/useHover';
import Tooltip from '~/components/molecule/Tooltip';
import type { SystemColorPalette } from '~/theme';

export type Props = {
  dataTestId?: string;
  label: React.ReactNode | string;
  tooltip: {
    message: string;
  };
  icon: {
    name: IconType;
    color: keyof SystemColorPalette;
  };
};

const CellWithTooltip: React.FCC<Props> = ({ label, tooltip, icon }) => {
  const theme = useTheme();
  const [showTooltip, hoverProps] = useHover();

  return (
    <JustificationContainer align="center" gap="xxs">
      <Icon
        name={icon.name || 'exclamation'}
        color={theme.color(icon.color || 'primary')}
        {...hoverProps}
        strokeWidth={2.5}
      />

      {showTooltip && (
        <StyledTooltip padding={['xs']}>{tooltip.message}</StyledTooltip>
      )}

      {label}
    </JustificationContainer>
  );
};

const StyledTooltip = styled(Tooltip)<{}>(
  ({ theme }) => css`
    top: ${theme.space('l')};
    left: ${theme.space('l')};
  `,
);

export default CellWithTooltip;
